import React from 'react';
import './Item.css';
import { Link } from 'react-router-dom';

const Item = (props) => {
  const isOutOfStock = Number(props.availableQuantity ?? 0) <= 0;

  return (
    <div className={`item ${isOutOfStock ? "item-out-of-stock" : ""}`}>
      <Link to={`/product/${props.id}`}>
        {/* Wrap the image in a div for styling */}
        <div className="item-image">
          <img 
            src={props.image} 
            alt={props.name} 
            loading="lazy"
            decoding="async"
            onClick={() => window.scrollTo(0, 0)} 
          />
          {isOutOfStock && <span className="item-stock-badge">Out of stock</span>}
        </div>
      </Link>

      <h3>{props.name}</h3>

      <div className="item-prices">
        {/* <span className="new-price">₦{props.price.toFixed(2)}</span> */}
        <span className="new-price">₦{(props.price || 0).toFixed(2)}</span>

      </div>
      {!isOutOfStock && Number(props.availableQuantity) <= 2 && (
        <span className="item-low-stock">Only {props.availableQuantity} left</span>
      )}
    </div>
  );
};

export default Item;
